import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Simple Promotion Modal that only shows on the user's first visit (per browser via localStorage)
export default function PromotionModal() {
  const STORAGE_KEY = "aalc_promo_seen_v1";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem(STORAGE_KEY);
      if (!seen) {
        // show modal on first visit
        setVisible(true);
        // mark as seen so it won't show again
        localStorage.setItem(STORAGE_KEY, "1");
      }
    } catch (e) {
      // If localStorage isn't available (very rare), avoid throwing — just don't show repeatedly
      console.warn("PromotionModal: localStorage unavailable", e);
    }
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setVisible(false);
    };
    if (visible) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible]);

  if (!visible) return null;

  // Inline styles to avoid creating a separate CSS file
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "1rem",
  };

  const modalStyle = {
    width: "100%",
    maxWidth: "560px",
    background: "linear-gradient(180deg,#fff,#fff)",
    borderRadius: "16px",
    padding: "2rem",
    boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "1.6rem",
    margin: "0 0 0.5rem 0",
    fontFamily: "'Playfair Display', serif",
  };

  const descStyle = { color: "#334155", marginBottom: "1.25rem" };

  const buttonStyle = {
    display: "inline-block",
    padding: "0.75rem 1.25rem",
    borderRadius: "999px",
    background: "linear-gradient(135deg, var(--primary-color), var(--accent-color))",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
    textDecoration: "none",
  };

  const closeStyle = {
    marginLeft: "0.75rem",
    background: "transparent",
    border: "none",
    color: "#334155",
    cursor: "pointer",
    fontSize: "0.95rem",
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Sitewide promotion"
      style={overlayStyle}
      onClick={() => setVisible(false)}
    >
      <div
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
  <h3 style={titleStyle}>Launch Special: 10% OFF e-books 🎁</h3>
  <p style={descStyle}>Celebrate our website launch — enjoy 10% off our e-book resources during the first week. Follow the link below to browse e-books and redeem at checkout.</p>

        <div style={{ display: "flex", justifyContent: "center", gap: "0.75rem", flexWrap: "wrap" }}>
          <Link to="/products" style={buttonStyle} onClick={() => setVisible(false)}>
            Browse E-books
          </Link>
          <button
            onClick={() => setVisible(false)}
            className="promo-close-btn"
            aria-label="Close promotion"
            style={closeStyle}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
